import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalAbout: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">
            {t('brand.name')}
          </Link>
          <Link to="/login" className="text-sm text-lotus-gold font-semibold">
            {t('legal.customerLogin')}
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-md p-8 space-y-8">
          <div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold">{t('legal.about.label')}</p>
            <h1 className="text-3xl font-bold text-gray-900 mt-2">{t('legal.about.title')}</h1>
            <p className="mt-4 text-gray-600 leading-relaxed">
              {t('legal.about.intro')}
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.about.visionTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.about.vision')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.about.featuresTitle')}</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>{t('legal.about.feature1')}</li>
              <li>{t('legal.about.feature2')}</li>
              <li>{t('legal.about.feature3')}</li>
              <li>{t('legal.about.feature4')}</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.contact')}</h2>
            <p className="text-gray-600">{t('contact.mainEmail')}</p>
            <p className="text-gray-600">{t('contact.legalPhone')}</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default LegalAbout;
